import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Title = styled.h4`
  ${({ theme }) => css`
    font-weight: ${theme.font.regular};
    margin-bottom: 20px;
  `}
`;
